import React, { useEffect, useState } from 'react'
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  CircularProgress,
} from '@mui/material'
import {
  AdminPanelSettings,
  Build,
  LocalShipping,
  Business,
  People,
} from '@mui/icons-material'
import { blue, grey } from '@mui/material/colors'
import api from '../../../config/api'

// Сопоставление статусов и иконок из MUI
const statusIcons = {
  админ: AdminPanelSettings,
  стафф: Build,
  опт: LocalShipping,
  'крупный опт': Business,
  'особо крупный опт': Business,
  пользователь: People,
}

const UserStatus = () => {
  const [status, setStatus] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  // Функция для получения статусов пользователя
  const fetchStatus = async () => {
    try {
      const response = await api.get('/API_FRONT/user/status/')
      setStatus(response?.data?.status || [])
    } catch (error) {
      console.error('Ошибка при получении статуса:', error)
      setError('Не удалось загрузить данные статуса')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchStatus()
  }, [])

  return (
    <Card sx={{ backgroundColor: grey[100], mb: 2 }}>
      <CardContent>
        <Grid container alignItems="center">
          <Grid item xs={3}>
            {loading ? (
              <Avatar sx={{ bgcolor: blue[300], width: 56, height: 56 }}>
                <CircularProgress size={24} />
              </Avatar>
            ) : (
              <Avatar sx={{ bgcolor: blue[500], width: 56, height: 56 }}>
                {status.length > 0 && statusIcons[status[0].toLowerCase()] ? (
                  React.createElement(statusIcons[status[0].toLowerCase()])
                ) : (
                  <People />
                )}
              </Avatar>
            )}
          </Grid>
          <Grid item xs={9}>
            {loading ? (
              <Typography variant="h6">Загрузка...</Typography>
            ) : error ? (
              <Typography variant="body1" color="error">
                {error}
              </Typography>
            ) : (
              <>
                <Typography variant="h6">Статус</Typography>
                <Typography sx={{ fontWeight: 'bold' }}>
                  {status.length > 0 ? status.join(', ') : 'Неизвестный статус'}
                </Typography>
              </>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default UserStatus
